(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ns-editorial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ns-editorial')) {
    customElements.define('ns-editorial', class extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
      }
      connectedCallback() {
        this.addEventListener('click', this.handleClick);
        this.addEventListener('change', this.handleColorChange);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('change', this.handleColorChange);
      }
      handleColorChange(event) {
        const input = event.target.closest('[data-ns-color]');
        if (!input) return;
        const piece = input.closest('.ns-piece');
        piece.querySelectorAll('[data-ns-color-image]').forEach((image) => {
          image.hidden = image.dataset.nsColorImage !== input.value;
        });
        const note = piece.querySelector('[data-ns-mockup-note]');
        if (note) note.hidden = input.value !== 'white';
      }
      handleClick(event) {
        const link = event.target.closest('[data-ns-expand]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const details = this.querySelector(link.getAttribute('href'));
        if (!details) return;
        event.preventDefault();
        details.open = true;
        details.querySelector('summary').focus({ preventScroll: true });
        details.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
